import Vue from "vue";
Vue.filter("getLinkForParent", function(item)
{
    let url = "/"+item.data.texts.urlPath;

    let value = "";

    if (item.data.hasOwnProperty("variationProperties"))
    {
        for (let i = 0; i < item.data.variationProperties.length; i++)
        {
            if (item.data.variationProperties[i].property.groupId == 7 && item.data.variationProperties[i].property.id == 94 )
            {
                value = item.data.variationProperties[i].values.value;
                url = "/"+item.data.variationProperties[i].values.value+"?variationId="+item.data.variation.id;
            }
        }
    }
    if (value=="")
    {
        value = item.data.item.id;
        url = url+"/a-"+value+"/";
    }
    return url;
});
